import { OPEN_SPOTLIGHT, CLOSE_SPOTLIGHT } from "../../actions";

export default function (oldSpotlight, action) {
    switch (action.type) {
        case OPEN_SPOTLIGHT:
            return true;
        case CLOSE_SPOTLIGHT:
            return false;
        default:
            return oldSpotlight;
    }
}





// WEBPACK FOOTER //
// ./src/redux/reducers/spotlight/index.js